import { uploadData } from 'aws-amplify/storage';
import type { UploadService } from '../types';
import { ensureAmplifyConfigured } from './amplifyConfig';

/**
 * Real uploads to the private S3 bucket via Amplify Storage. The key is
 * `uploads/<cognito-identity-id>/<submissionId>/<filename>`, consistent with
 * the API and presigned channels (which use the supplier client_id as the
 * identity segment). The leading identity segment matches the IAM policy that
 * scopes each supplier to their own prefix; the submissionId is a per-upload id
 * the normalizer reads from the path, so the filename can be anything. Amplify
 * signs the request using the temporary credentials from the Identity Pool.
 */
export const awsUploadService: UploadService = {
    async uploadFile(file: File, onProgress?: (percent: number) => void): Promise<void> {
        ensureAmplifyConfigured();

        const submissionId = crypto.randomUUID();

        await uploadData({
            // identityId is injected by Amplify for the signed-in user.
            path: ({ identityId }) => `uploads/${identityId}/${submissionId}/${file.name}`,
            data: file,
            options: {
                contentType: file.type || 'application/octet-stream',
                onProgress: ({ transferredBytes, totalBytes }) => {
                    if (totalBytes) {
                        onProgress?.(Math.round((transferredBytes / totalBytes) * 100));
                    }
                },
            },
        }).result;
    },
};

export default awsUploadService;
